"use client";

// src/components/ui/layout/hero/HeroGlitchStyles.tsx

import "./HeroGlitchStyles.css";

export function HeroGlitchStyles() {
  return null;
}
